import React from 'react'
import styleBlogContent from './CSS/styleBlogContent.css'

export default function Blogcontent() {
    return (
        <div>
            
    <div className="blogContainer">
      <div className="blog__container">
        <div className="genre__Date">
          <p className="genre">DIET<span className="Date"> • JAN 23, 2021</span></p>
        </div>
        <div className="blog__title">
          <h3 className="title">
            Living with PCOS: My story, Menstrual Health, Talking Periods.
          </h3>
        </div>
        <div className="minRead">
          <p className="minRead_p">
            In this blog, Ashley shares her experiences of PCOS.
            <span className="minRead_span"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;6 min</span>
          </p>
        </div>
        <div className="blog__img">
          <img
            className="img__blog"
            src="https://euassets.totmcdn.com/v4/2021/01/Untitled-design-29-1.png"
            alt=""
          />
        </div>
        <div className="blogContent">
          <p className="content_desc">
            Ashley has served as an executive and advisor to many PCOS and
            Women’s Health Organizations. She has made multiple appearances
            including Discovery Health Mystery Diagnosis, Woman’s World, Fox
            News and Glamour Magazine as a finalist for 2008 Woman of the Year.
            Her other achievements include WEGO #HAAwards Finalist 2016; 2016
            Ricardo Azziz PCOS Challenge; and Advocacy Leadership Award.
          </p>
          <p className="content_heading">Where It all began ?</p>
          <p className="content_desc">
            At age 13, I had menstrual irregularities that were quite
            significant. So much so that I was taken to an OBGYN
            (obstetrician-gynecologist). I was afraid and unaware. He said many
            girls combat menstrual irregularities and some need help so, at age
            13 I was put on birth control pills. Throughout the duration of
            being on the pill, I noticed some fluctuations with weight gain and
            acne break outs and saw some hairs popping up in unusual places like
            my chin. However, it was chalked up to it being a coming of age
            thing and there was never any further investigation as to probable
            causes for these symptoms.
          </p>
          <p className="content_heading">Seeking Help</p>
          <p className="content_desc">
            Move forward to age 29. After more than 10 years of being on BCPs, I came off them to start a family. Within three months I gained over 100 pounds, had adult acne and noticed a significant increase in facial hair. On top of this, I was not getting a menstrual cycle and was not pregnant. I immediately sought help. I started with my general practitioner, who insisted I was over eating because of anxiety formulated from trying to get pregnant. I moved on to two more doctors who came to the same theory, regardless of the fact had not changed any of my eating habits!

Finally, I made one more appointment with a young doctor. I began by explaining how I had been to multiple doctors and had no luck, then told him the story of my symptoms. After listening, his eyes became wide. He told me to hang on and walked out of the room. When he returned he had a text book open on a page, telling me he believed this was what I was dealing with. The page was titled ‘Polycystic Ovary Syndrome’ – also known as PCOS. He said that he did not know much about the syndrome, but he would work with me to learn and help me get answers.
          </p>
          <p className="content_heading">Treating the PCOS</p>
          <p className="content_desc">
            It was not until I accepted that I was the one in control of my destiny, that things changed. I went to the PCOS Center in Philadelphia run by Dr Katherine Sherif, which offered a multidisciplinary approach to the treatment of PCOS. As an alternative to just taking medications, I was taught that lifestyle changes, along with my diet and exercise were key in controlling the symptoms.

I started off very simple. I wore a pedometer and made it my goal to take 10,000 steps a day, which helped me get motivated and lose weight. Over time, steps turned into a jog, then into a run and eventually working out at the gym. In addition, I started to pay attention to the nutritional needs of my body. I realised a diet was not meant to starve my body, but to nourish it with the proper foods.

Unfortunately, doctors can only currently treat the individual symptoms of women with PCOS – rather than the entire syndrome. Once diagnosed, it can be managed effectively in most patients to help them lead healthier and more satisfying lifestyles. In the meantime, research continues to determine the cause and look for new and better treatments for PCOS.

There are diets, supplements, exercises and medications that can help so it’s important to take the first step and work with a professional who knows PCOS.

Bottom line treatments are just as varied as the symptoms, find what works best for you and take your time getting to where you want to be. Nothing happens over night, realising this is the biggest and most valuable step you can take!
          </p>
        </div>
      </div>
    </div>
    
        </div>
    )
}
